import styled, { css } from 'styled-components';
import { StyledLegendItemProps } from './types';
import { LegendVariant } from '../../types';
import { Theme } from '@redsift/design-system';

/**
 * Component style.
 */
export const StyledLegendItem = styled.li<StyledLegendItemProps>`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: var(--redsift-typography-caption-font-size);

  ${({ $theme }) => css`
    color: var(--redsift-color-neutral-${$theme === Theme.dark ? 'white' : 'x-dark-grey'});
  `}

  ${({ $variant, $color }) =>
    $variant !== LegendVariant.custom
      ? css`
          > div {
            height: 16px;
            width: 16px;
            min-width: 16px;
            background-color: ${$color};
          }
        `
      : ''}

  ${({ $clickable }) =>
    $clickable
      ? css`
          cursor: pointer;

          &:hover,
          &:focus {
            outline: none;
            > div {
              opacity: 0.7;
            }
          }

          &:focus-visible {
            > div {
              outline: 4px solid var(--redsift-color-primary-n);
            }
          }
        `
      : ''}
`;
